// extracted by mini-css-extract-plugin
export default {"header":"page_title_header__EuNet","subline":"page_title_subline__1UuPe","subHeader":"page_title_subHeader__fk9Jf","heart":"page_title_heart__kREa-"};